import users from './users';
import cards from './cards';
import login from './login';
import common from './common';
import maps from './maps';
import ec from './ec';
import statement from './statement';

function apiHelper() {
  return { users, login, common, cards, maps, ec, statement };
}

const api = apiHelper();

export { users, login, common, cards, maps, ec, statement };
export default api;
